'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider
    .state('logout', {
      url: '/logout?referrer',
      referrer: 'main',
      template: '',
      controller($state, Auth) {
        'ngInject';

        var referrer = $state.params.referrer || $state.current.referrer || 'main';
        Auth.logout();
        $state.go(referrer);
      }
    })
    .state('register', {
      url: '/register',
      template: require('./signup/signup.html'),
      controller: 'SignupController',
      controllerAs: 'vm'
    })
    .state('forgot-password', {
      url: '/forgot-password',
      template: require('./forgot-password/forgot-password.html'),
      controller: 'ForgotPasswordController',
      controllerAs: 'vm'
    })
    .state('reset-password', {
      url: '/reset/:id/:token',
      template: require('./reset-password/reset-password.html'),
      controller: 'ResetPasswordController',
      controllerAs: 'vm'
    })
    .state('change-password', {
      url: '/change-password',
      template: require('./change-password/change-password.html'),
      controller: 'ChangePasswordController',
      controllerAs: 'vm',
      authenticate: true
    })
    .state('activate-webaccess', {
      url: '/webaccess/activate/:webaccessId/:token',
      template: require('./activate-webaccess/activate-webaccess.html'),
      controller: 'ActivateWebaccessController',
      controllerAs: 'vm'
    })
    .state('reset-password-webaccess', {
    url: '/webaccess/reset/:id/:token',
    template: require('./reset-password-suite-webaccess/reset-password-suite-webaccess.html'),
    controller: 'ResetPasswordSuiteWebaccessController',
    controllerAs: 'vm'
  });
}



// WEBPACK FOOTER //
// ./client/app/account/account.routes.js